import { PageHeader } from '@fukuri-admins/ui/common';

type Item = {
  /** 表示テキスト */
  label: string;
  /** リンク先 */
  href?: string;
};

type Props = {
  breadcrumbItems: Item[];
};

/**
 * 契約プラン詳細ヘッダー Presentation コンポーネント
 *
 * breadcrumb: 契約プラン → {プラン名}
 */
export const ContractPlanDetailHeaderPresentation: React.FC<Props> = ({ breadcrumbItems }) => (
  <PageHeader variant='breadcrumb' breadcrumbItems={breadcrumbItems} />
);
